export const GET_CUSTOMERS = 'GET_CUSTOMERS';
export const GET_CUSTOMERS_ERROR = 'GET_CUSTOMERS_ERROR';
export const GET_CUSTOMERS_REQUEST = 'GET_CUSTOMERS_REQUEST';
export const GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMERS_SUCCESS';

export const SET_CUSTOMERS = 'SET_CUSTOMERS';
